
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.694 1.5c-.145 0-.29.05-.408.15l-1.798 1.546c-1.056-.629-2.24-1.02-3.49-1.02-2.862 0-5.417 2.12-6.883 4.422V6.6a.763.763 0 00-.001.802c.62.974 1.432 1.912 2.377 2.67L.9 11.442a.6.6 0 00-.209.454.61.61 0 00.616.605.62.62 0 00.407-.15l11.388-9.792a.598.598 0 00.209-.453.61.61 0 00-.616-.605zm-9.27 7.77A9.808 9.808 0 011.318 7C2.604 5.097 4.677 3.384 7 3.384c.889 0 1.737.243 2.517.649l-.826.71A2.887 2.887 0 007 4.2C5.423 4.2 4.14 5.453 4.14 7c0 .49.13.95.355 1.35l-1.07.92zM5.375 7c0-.876.726-1.59 1.626-1.59.26 0 .504.06.722.165l-2.26 1.943A1.552 1.552 0 015.373 7z","fill":"#1C2F45"}}),_c('path',{attrs:{"d":"M12.167 4.482l-.065-.062-.924.796.079.075A9.82 9.82 0 0112.687 7c-1.263 1.91-3.332 3.616-5.688 3.616a5.06 5.06 0 01-1.68-.295l-.054-.02-1.022.879.142.063c.822.367 1.703.582 2.614.582 2.907 0 5.454-2.118 6.891-4.431v-.001a.761.761 0 000-.786v-.001a10.966 10.966 0 00-1.723-2.124z","fill":"#1C2F45"}}),_c('path',{attrs:{"d":"M9.826 6.576L9.8 6.401 8.554 7.473l-.01.025c-.18.54-.653.954-1.236 1.063l-.026.005L6.033 9.64l.176.05c.251.071.517.11.791.11 1.577 0 2.86-1.253 2.86-2.8 0-.144-.012-.286-.034-.424z","fill":"#1C2F45"}})])
          )
        }
      }
    